import random from 'toxilibs/random.js'
import Level from '../../core/level.js'

const level = new Level({
    name: 'signs_rule',
    dependencies: [
        'levels_maths/berengere_maths/signs_rule_simple'
    ]
})



//FIXME -1, -1, -1, -1, -1

//FIXME -1, 1, 1, -1, 1

// pas de notation puissance, ici, la mettre dans power signs rule

function question (q, values) {
    let result = 1
    let s = ''
    for (let i = 0; i < values.length; i++) {
        let number = values[i]
        result *= number

        s += number < 0 ? '(' + number + ')' : number

        if (i < values.length - 1) {
            s += 'xx'
        }
    }
    q.addMathFormula(s)
    q.answer = [
        result,
        q.evalAnswer(result)
    ]
}




//Intuiter l'impact du nombre (pair ou pas) de facteurs dans le produit sur le signe. (base de 3)
level.addQuestion({
    generator: function (q) {
        let val = -random.fairChoiceInt(1, 3)
        question(q, Array(3).fill(val))
    }
})



//Intuiter l'impact du nombre (pair ou pas) de facteurs dans le produit sur le signe. (base de 4)
level.addQuestion({
    generator: function (q) {
        let val = -random.fairChoiceInt(1, 3)
        question(q, Array(4).fill(val))
    }
})



level.addQuestion({
    generator: function (q) {
        question(q, Array(random.fairChoiceInt(3, 7)).fill(-1))
    },
    times: 2
})



level.addQuestion({
    generator: function (q) {
        let values = []
        let amount = random.fairChoiceInt(3, 7)
        for (let i = 0; i < amount; i++) {
            values.push(random.fairChoice([1, -1]))
        }
        question(q, values)
    },
    times: 2
})



export default level


